import { render, staticRenderFns } from "./LeaderboardEntry.vue?vue&type=template&id=4a0af97a&scoped=true&lang=html&"
import script from "./LeaderboardEntry.vue?vue&type=script&lang=js&"
export * from "./LeaderboardEntry.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardEntry.vue?vue&type=style&index=0&id=4a0af97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0af97a",
  null
  
)

export default component.exports